module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_vm._v("\n\t投资者选择想要购买的产品，输入预约金额，对投资者信息、风险承受能力、经办人授权函（如有）、投资者主体（如有）进行确认，并同意采用以上信息进行数字证书申请。\n\t"), _c('div', {
    staticClass: "stress-content"
  }, [_vm._v("\n\t\t界面提示有3秒的强阅读时间，防止投资者误点出错。\n\t")]), _vm._v(" "), _c('div', {
    staticClass: "picture"
  }, [_c('van-swipe', {
    ref: "vanswipe",
    attrs: {
      "show-indicators": _vm.showindicators
    },
    on: {
      "change": _vm.onChange
    }
  }, [_c('van-swipe-item', [_c('img', {
    attrs: {
      "src": require("../../common/images/invite1.png"),
      "width": "100%"
    }
  })]), _vm._v(" "), _c('van-swipe-item', [_c('img', {
    attrs: {
      "src": require("../../common/images/invite2.png"),
      "width": "100%"
    }
  })])], 1), _vm._v(" "), _c('my-stepper', {
    attrs: {
      "current_step": _vm.currentStep,
      "total_step": "02"
    },
    on: {
      "leftClick": _vm.leftClick,
      "rightClick": _vm.rightClick
    }
  }, [_vm._v(_vm._s(_vm.message))])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64ed6332"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Guide/appointmentGuide.vue
// module id = 1064
// module chunks = 1